import { UIRouter } from '@uirouter/core';
import { AreasRegistry, RegistryItem } from './areas.service';

export class AreasRegistryContext {
    areas: RegistryItem[];

    constructor(public registry: AreasRegistry, public router: UIRouter) {
        this.areas = registry.areas;
    }

    isActive = (stateRegistryItem) => {
        const checkForState = stateRegistryItem.activeWhen || stateRegistryItem.state || stateRegistryItem.name.toLowerCase();
        return this.router.stateService.includes(checkForState);
    }


    // WS5 #10 Stage B B5b: was `this.$injector.invoke(handler)`. The handler path is dead
    // at runtime — ZERO HandlerRegistryItem registrations exist tree-wide (every area is a
    // StateRegistryItem/MultipleOptionsRegistryItem), so the template's
    // `*ngIf="...handler"` guards are always false and `invoke` is never reached with a
    // real handler. Native direct-call preserves the (unreachable) contract without the
    // AngularJS `$injector`.
    invoke = ($event, handler) => {
        if (!!handler) {
            if ($event.cancelable) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            handler();
        }
    }
}
